import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import request from "../../../Helpers/API"; // Asegúrate de que esta ruta sea correcta

const ClienteAutocompleteEditar = ({ onSelectCliente, idCliente }) => {
  const [clientesList, setClientesList] = useState([]);
  const [clientesearch, setClientesearch] = useState("");

  useEffect(() => {
    // Cargar la lista de clientes al montar el componente
    request
      .get("ClientesEspeciales/DropDownListTodos")
      .then((result) => {
        setClientesList(result);
      })
      .catch((error) => {
        console.error("Error fetching clientes:", error);
      });
  }, []);

  useEffect(() => {
    // Establecer el valor inicial del Autocomplete basado en idCliente
    if (idCliente) {
      const idClienteString = idCliente.toString();
      const selectedCliente = clientesList.find(cliente => cliente.idCliente === idClienteString);
      if (selectedCliente) {
        setClientesearch(`${selectedCliente.idCliente} - ${selectedCliente.razon_social}`);
      }
    }
  }, [idCliente, clientesList]);

  return (
    <Autocomplete
      size="small" // Tamaño del Autocomplete
      options={clientesList.map((option) => `${option.idCliente} - ${option.razon_social}`)}
      value={clientesearch} // Establecer el valor del Autocomplete
      disabled // Deshabilitar el Autocomplete
      renderInput={(params) => (
        <TextField
          {...params}
          label="Cliente"
          fullWidth // Asegúrate de que ocupe todo el ancho
          size="small" // Tamaño del TextField
          variant="outlined"
          sx={{
            mt: 2, // Margen superior
          }}
        />
      )}
    />
  );
};

export default ClienteAutocompleteEditar;